export class PostPageError extends Error {
  pageIndex: number

  isMediaMissing: boolean

  constructor(message: string, pageIndex: number, isMediaMissing = false) {
    super(message)
    this.pageIndex = pageIndex
    this.isMediaMissing = isMediaMissing

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, PostPageError.prototype)
  }
}
